const initialState = {
  values: {},
  validations: {
    contact_name: false,
    name: false,
    description: false,
    contact_phone: false,
    contact_email: false,
  },
  error: false,
  saving: false,
  editing: false,
  create_manager: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_AGENCY_SAVE':
      return { ...state, saving: true, errors: {} };
    case 'ADD_AGENCY_CLEAR_SAVE':
      return { ...state, saving: false };
    case 'ADD_AGENCY_ERROR':
      return { ...state, error: true };
    case 'CLEAR_AGENCY_ERROR':
      return { ...state, error: false };
    case 'EDIT_ADD_AGENCY': {
      const values = { ...state.values, [action.id]: action.value };
      const validations = { ...state.validations, [action.id]: action.valid };
      return { ...state, values, validations };
    }
    case 'TOGGLE_CREATE_MANAGER': {
      return {
        ...state,
        create_manager: action.payload,
      };
    }
    case 'SET_EDIT_AGENCY_INFO': {
      const values = action.payload;
      const newValidations = {};
      Object.keys(action.payload).forEach((validation) => {
        newValidations[validation] = true;
      });
      return {
        ...state,
        values,
        validations: newValidations,
        editing: action.edit,
      };
    }
    case 'CLEAR_ADD_AGENCY':
      return { ...initialState };
    default:
      return state;
  }
};
